import _ from 'lodash'
/**
 * 系统预设付费表
 */

// 新零售-收银台位
export const NEW_LS_CASHIER_PART = [
    { "fee_code": 1001, "shop_type": "new_ls", "goods_item": "收银台位", "goods_type": 1, "size": "" },
]

// 新零售-年服务费
export const NEW_LS_ANNUAL_FEE = [
    { "fee_code": 1002, "shop_type": "new_ls", "goods_item": "年服务费", "goods_type": 2, "size": "标准版" },
    { "fee_code": 1003, "shop_type": "new_ls", "goods_item": "年服务费", "goods_type": 2, "size": "专业版" },
    { "fee_code": 1004, "shop_type": "new_ls", "goods_item": "年服务费", "goods_type": 2, "size": "旗舰版" },
]

// 老零售-收银台费用
export const OLD_LS_CASHIER_PART = [
    { "fee_code": 1005, "shop_type": "old_ls", "goods_item": "收银台费用", "goods_type": 1, "size": "" },
]

// 老零售-微商城费用
export const OLD_LS_MINI_SHOP = [
    { "fee_code": 1006, "shop_type": "old_ls", "goods_item": "微商城费用", "goods_type": 2, "size": "入门版" },
]

// 批发-初装费
export const PF_INSTALL_FEE = [
    { "fee_code": 1007, "shop_type": "pf", "goods_item": "初装费", "goods_type": 1, "size": "" },
]

// 批发-短信额度
export const PF_SMS_FEE = [
    { "fee_code": 1008, "shop_type": "pf", "goods_item": "短信额度", "goods_type": 2, "size": "500 条" },
    { "fee_code": 1013, "shop_type": "pf", "goods_item": "短信额度", "goods_type": 2, "size": "2000 条" },
    { "fee_code": 1014, "shop_type": "pf", "goods_item": "短信额度", "goods_type": 2, "size": "10000 条" },
    { "fee_code": 1018, "shop_type": "pf", "goods_item": "短信额度", "goods_type": 2, "size": "50000 条" },
    { "fee_code": 1019, "shop_type": "pf", "goods_item": "短信额度", "goods_type": 2, "size": "200 条" },
    { "fee_code": 1020, "shop_type": "pf", "goods_item": "短信额度", "goods_type": 2, "size": "500 条" },
    { "fee_code": 1021, "shop_type": "pf", "goods_item": "短信额度", "goods_type": 2, "size": "1000 条" },
]

// 批发-系统年费
export const PF_ANNUAL_FEE = [
    { "fee_code": 1009, "shop_type": "pf", "goods_item": "系统年费", "goods_type": 3, "size": "定制版" },
    { "fee_code": 1039, "shop_type": "pf", "goods_item": "系统年费", "goods_type": 3, "size": "标准版" },
    { "fee_code": 1040, "shop_type": "pf", "goods_item": "系统年费", "goods_type": 3, "size": "专业版" },
    { "fee_code": 1041, "shop_type": "pf", "goods_item": "系统年费", "goods_type": 3, "size": "高级版" },
    { "fee_code": 1042, "shop_type": "pf", "goods_item": "系统年费", "goods_type": 3, "size": "旗舰版" }
]

/**
 * 微商城-系统年费
 */
export const WSC_ANNUAL_FEE = [
    { "fee_code": 1010, "shop_type": "wsc", "goods_item": "系统年费", "goods_type": 1, "size": "入门版" },
    { "fee_code": 1011, "shop_type": "wsc", "goods_item": "系统年费", "goods_type": 1, "size": "标准版" },
    { "fee_code": 1012, "shop_type": "wsc", "goods_item": "系统年费", "goods_type": 1, "size": "专业版" },
]

// 新零售-初装费
export const NEW_LS_INSTALL_FEE = [
    { "fee_code": 1015, "shop_type": "new_ls", "goods_item": "初装费", "goods_type": 3, "size": "标准版" },
    { "fee_code": 1016, "shop_type": "new_ls", "goods_item": "初装费", "goods_type": 3, "size": "专业版" },
    { "fee_code": 1017, "shop_type": "new_ls", "goods_item": "初装费", "goods_type": 3, "size": "旗舰版" },
]

// 新零售-微商城
export const NEW_LS_MINI_SHOP = [

    { "fee_code": 1022, "shop_type": "new_ls", "goods_item": "微商城费用", "goods_type": 4, "size": "基础版" },
    { "fee_code": 1023, "shop_type": "new_ls", "goods_item": "微商城费用", "goods_type": 4, "size": "专业版" },
    { "fee_code": 1024, "shop_type": "new_ls", "goods_item": "微商城费用", "goods_type": 4, "size": "旗舰版" },
]

// 新零售-商品分组
export const NEW_LS_GOODS_GROUP = [
    { "fee_code": 1025, "shop_type": "new_ls", "goods_item": "商品分组", "goods_type": 5, "size": "5 个" },

]

// 批发-收银台挂单数
export const PF_PENDING_ORDER = [
    { "fee_code": 1026, "shop_type": "pf", "goods_item": "收银台挂单数", "goods_type": 4, "size": "1 个" },

]

// 批发-付费声源播报次数
export const PF_AUDIO_FEE = [
    { "fee_code": 1027, "shop_type": "pf", "goods_item": "付费声源播报次数", "goods_type": 4, "size": "1万次" },
]

// 新零售-付费声源播报次数
export const NEW_LS_AUDIO_FEE = [
    { "fee_code": 1028, "shop_type": "new_ls", "goods_item": "付费声源播报次数", "goods_type": 4, "size": "1万次" },

]

// 新零售-会员导出
export const NEW_LS_EXPORT_CUSTOMER = [
    { "fee_code": 1029, "shop_type": "new_ls", "goods_item": "会员导出", "goods_type": 7, "size": '1次' },

]

// 新零售-员工数量上限
export const NEW_LS_STAFF_SEAT = [
    { "fee_code": 1094, "shop_type": "new_ls", "goods_item": "员工数量上限", "goods_type": 1, "size": "1个" },
]

// 批发-自定义资金账户数量
export const PF_CUSTOM_FUND = [
    { "fee_code": 1030, "shop_type": "pf", "goods_item": "自定义资金账户数量", "goods_type": 8, "size": "1 个" },
]

// 批发-视频监控
export const PF_VIDEO_WATCH = [
    { "fee_code": 1031, "shop_type": "pf", "goods_item": "视频监控云存储服务", "goods_type": 9, "size": "720P 视频存储周期 1 个月" },
    { "fee_code": 1032, "shop_type": "pf", "goods_item": "视频监控云存储服务", "goods_type": 9, "size": "720P 视频存储周期 3 个月" },
    { "fee_code": 1033, "shop_type": "pf", "goods_item": "视频监控云存储服务", "goods_type": 9, "size": "720P 视频存储周期半年" },
    { "fee_code": 1034, "shop_type": "pf", "goods_item": "视频监控云存储服务", "goods_type": 9, "size": "720P 视频存储周期 1 年" },
    { "fee_code": 1035, "shop_type": "pf", "goods_item": "视频监控云存储服务", "goods_type": 9, "size": "1080P 视频存储周期 1 个月" },
    { "fee_code": 1036, "shop_type": "pf", "goods_item": "视频监控云存储服务", "goods_type": 9, "size": "1080P 视频存储周期 3 个月" },
    { "fee_code": 1037, "shop_type": "pf", "goods_item": "视频监控云存储服务", "goods_type": 9, "size": "1080P 视频存储周期半年" },
    { "fee_code": 1038, "shop_type": "pf", "goods_item": "视频监控云存储服务", "goods_type": 9, "size": "1080P 视频存储周期 1 年" },
]

// 批发-云结算台新增台位（安装费）
export const PF_SELF_SERVICE_PART = [
    { "fee_code": 1043, "shop_type": "pf", "goods_item": "森果云结算台年费", "goods_type": 1, "size": "1套1年" },
]

// 批发-云结算台台位费
export const PF_SELF_SERVICE_ANNUAL_FEE = [
    { "fee_code": 1044, "shop_type": "pf", "goods_item": "森果云结算台年费", "goods_type": 1, "size": "1套1年" },
]

// 批发-员工数量
export const PF_STAFF_NUM = [
    { "fee_code": 1067, "shop_type": "pf", "goods_item": "员工数量", "goods_type": 1, "size": "1个1年" },
]


export const PF_MULTIPLE_SALE_POINT = [
    {"fee_code": 1090, "shop_type": "pf","goods_item": "多销售点购买","goods_type": 1 ,"size": "1个"}, 
    {"fee_code": 1092, "shop_type": "pf","goods_item": "多销售点续费","goods_type": 1 ,"size": "1个"}, 
]

export const PF_YEARLY_VERSION_RENEWAL_FEE = [
    {"fee_code": 1091, "shop_type": "pf","goods_item": "年度续费","goods_type": 1 ,"size": "1个"}, 
]

// 检查费用类型
export function checkFeeInfo(feeCode, list) {
    if (!feeCode) return false
    if (!_.isNumber(feeCode)) {
        throw new Error("请传入正确的FeeCode")
    }
    const newList = _.flatten(list)
    return newList.some(v => v.fee_code === feeCode)
}
